import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { SearchScenarioId } from 'owa-search-store';

export function isSearchBoxWin32ParityEnabled(scenarioId: SearchScenarioId): boolean {
    return (
        isGlobalFeatureEnabled('sea-searchBoxWin32Parity') &&
        (scenarioId === SearchScenarioId.Mail || scenarioId === SearchScenarioId.Calendar)
    );
}
